import React from 'react';
import { FadeIn } from './FadeIn';
export function TheProblem() {
  return <section className="py-24 bg-linen" data-id="element-90">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-91">
        <FadeIn data-id="element-92">
          <div className="bg-white p-10 md:p-16 rounded-2xl shadow-warm relative overflow-hidden" data-id="element-93">
            <div className="absolute top-0 left-0 w-2 h-full bg-terracotta" data-id="element-94"></div>

            <h2 className="text-3xl md:text-4xl text-charcoal mb-8" data-id="element-95">
              El problema no es que seas desordenada.
            </h2>

            <p className="text-xl text-charcoal font-medium mb-8 leading-relaxed" data-id="element-96">
              El problema es que intentas aplicar rutinas diseñadas para
              personas que tienen tiempo y energía de sobra.
            </p>

            <p className="text-lg text-warmgray leading-relaxed mb-6" data-id="element-97">
              Las limpiezas profundas de los sábados son una tortura que se
              arruina el lunes por la tarde. El "Meal Prep" de los domingos te
              obliga a comer sobras recalentadas que ni te apetecen.
            </p>

            <p className="text-lg text-warmgray leading-relaxed" data-id="element-98">
              Intentas mantener el control, pero la{' '}
              <span className="font-semibold text-charcoal" data-id="element-99">
                "Fatiga Decisional"
              </span>{' '}
              hace que termines pidiendo comida a domicilio o ignorando el
              desorden hasta que explotas de frustración.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}